export { default as AutoScaledImage } from './auto-scaled-image';
